import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import fb from "../Firebase/firebase";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UpArrow from '../Utilities/UpArrow';
const DB = fb.firestore()
const CF = DB.collection('Emarco_Form');

const Home = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const href = window.location.href.substring(
      window.location.href.lastIndexOf('#') + 1
    );
    const element = document.getElementById(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }

  }, []);

  const form = useRef();
  const [userData, setUserData] = useState({
    Name: "",
    Email: "",
    Mobile: "",
    Quantity: "",
    RetailerSelfUse: ""
  });

  let name, value;
  const postUserData = (e) => {
    name = e.target.name;
    value = e.target.value;
    setUserData({ ...userData, [name]: value });
  }

  //connect with firebase
  const SubmitData = async (e) => {
    e.preventDefault();
    const { Name, Email, Mobile, Quantity, RetailerSelfUse } = userData;
    if (Name && Email && Mobile && Quantity && RetailerSelfUse) {


      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(userData.Email)) {
        toast.warning('Please enter a valid email address');
        return
      }

      if (typeof Mobile !== "undefined") {

        var pattern = new RegExp(/^[0-9\b]+$/);

        if (!pattern.test(userData.Mobile)) {
          toast.warning("Please enter only number.");
          return

        } else if (userData.Mobile.length !== 10) {
          toast.warning("Please enter 10 digit Mobile number.");
          return
        }
      }

      try {

        CF.add({
          Name: Name,
          Email: Email,
          Mobile: Mobile,
          Quantity: Quantity,
          RetailerSelfUse: RetailerSelfUse
        }).then((docRef) => {
          toast.success('Order Received Successfully');
        }).catch((error) => {
          console.error("error:", error);
        });

        emailjs.sendForm('service_91sqknx', 'template_4j6wwya', form.current, '6pbmyufjSURA60XeS')
        .then((result) => {
          console.log(result.text);

        }, (error) => {
          console.log(error.text);
        });

        setUserData({
          Name: "",
          Email: "",
          Mobile: "",
          Quantity: "",
          RetailerSelfUse: ""
        })

        // console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
        toast.warning("Error adding document")
      }
    }
    else {
      toast.warning('Please fill the data');
    }
  };

  // Header
  const [display, setDisplay] = useState("none");

  const show = () => {
    setDisplay("block");
  }

  const hide = () => {
    setDisplay("none");
  }

  const up = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setDisplay("none");
  }

  const [animation, setAnimation] = useState("zoom-in-zoom-out 2s ease-out 1");

  const down = () => {
    window.scrollTo({ top: 10000, left: 0 });
    setDisplay("none");

    if (animation === "zoom-in-zoom-out 2s ease-out 1") {
      setAnimation("none");
    }
    else {
      setAnimation("zoom-in-zoom-out 2s ease-out 1");
    }
  }

  const hidden = () => {
    setDisplay("none");
  }
  // Header Ends


  return (
    <div>
      {/* Header */}
      <header>
        <div className="logo">
          <img rel='preload' fetchpriority="high" src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702898991/EMarco/logo_atkhot.png" alt="logo" />
        </div>
        <div className="links">
          <Link to={"/"} onClick={up}>Home</Link>
          <a onClick={hidden} href="#about">About Emarco</a>
          <a href="#contact-us" onClick={down}>Contact Us</a>
          <a onClick={hidden} href="#buy">Buy Now</a>
        </div>

        <div id='navbar-mobile' style={{ display: display }}>
          <svg className='cross' onClick={hide} id="Capa_1" enable-background="new 0 0 320.591 320.591" height="512" viewBox="0 0 320.591 320.591" width="512" xmlns="http://www.w3.org/2000/svg"><g><g id="close_1_"><path d="m30.391 318.583c-7.86.457-15.59-2.156-21.56-7.288-11.774-11.844-11.774-30.973 0-42.817l257.812-257.813c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875l-259.331 259.331c-5.893 5.058-13.499 7.666-21.256 7.288z" /><path d="m287.9 318.583c-7.966-.034-15.601-3.196-21.257-8.806l-257.813-257.814c-10.908-12.738-9.425-31.908 3.313-42.817 11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414-6.35 5.522-14.707 8.161-23.078 7.288z" /></g></g></svg>

          <div className="links">
            <Link to={"/"} onClick={up}>Home</Link>
            <a onClick={hidden} href="#about">About Emarco</a>
            <a onClick={down} href="#contact">Contact</a>
            <a onClick={hidden} href="#buy">Buy Now</a>

          </div>
        </div>
        <svg className='menu' onClick={show} id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m512 256.002c0 17.673-14.327 32-32 32h-307.059c-17.673 0-32-14.327-32-32s14.327-32 32-32h307.059c17.673 0 32 14.327 32 32zm-339.059-134.55h307.059c17.673 0 32-14.327 32-32s-14.327-32-32-32h-307.059c-17.673 0-32 14.327-32 32s14.328 32 32 32zm307.059 269.096h-307.059c-17.673 0-32 14.327-32 32s14.327 32 32 32h307.059c17.673 0 32-14.327 32-32s-14.327-32-32-32zm-419.195-333.096h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32zm0 166.551h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32zm0 166.542h-28.805c-17.673 0-32 14.327-32 32s14.327 32 32 32h28.805c17.673 0 32-14.327 32-32s-14.327-32-32-32z" /></svg>

      </header>
      {/* Header Ends */}
      <ToastContainer />
      <UpArrow />
      <div>
        {/* ======= Hero Section ======= */}

        <div className="banner">
          <div className="banner-caption">
            <div className="banner-text">
              <p>Welcome To  <br />&emsp;Emarco </p>
              <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1701934636/B-Marco/shape_ybefzo.webp" alt="shape" />
            </div>

            <div className='button'>
              <svg id="Layer_1" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m352 342.772c30.147 0 48.063-4.725 61.841-16.308 13.5-11.347 20.878-27.689 30.6-51.324l66.359-161.387a16 16 0 0 0 -14.8-22.085h-415.577l-10.391-46.48a16 16 0 0 0 -15.615-12.509h-38.417a16 16 0 0 0 0 32h25.6l58.986 263.86v31.1a47.883 47.883 0 0 0 47.829 47.829h1.553a44.647 44.647 0 1 0 70.724 0h117.408a44.647 44.647 0 1 0 70.724 0h32.428a16 16 0 0 0 0-32h-292.837a15.847 15.847 0 0 1 -15.829-15.829v-16.867zm-166.669 104.549a12.647 12.647 0 1 1 12.646-12.647 12.661 12.661 0 0 1 -12.646 12.647zm188.126 0a12.647 12.647 0 1 1 12.643-12.647 12.661 12.661 0 0 1 -12.643 12.647zm-285.881-323.653h384.546l-57.279 139.3c-16.269 39.568-19.655 47.8-62.842 47.8h-222.601z" /></svg>
              <a href='#buy'>buy now</a>
            </div>
          </div>

          <div className="banner-img">
            <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702899017/EMarco/Products/1_uqqdx2.png" alt="banner" />
            <div id="about"></div>
          </div>
        </div>

        <svg className='wave' viewBox="0 0 100 25">
          <defs>
            <pattern id="Wave"
              x="0" y="0" width="100" height="25"
              patternUnits="userSpaceOnUse" >
              <path d="M0 25 0 6C20 9 38 11 55 7 72 4 87 4 100 6l0 19z" id="path4" fill="#F99931" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#Wave)" />
        </svg>

        <main id="main">
          {/* ======= About Section ======= */}
          <section class="about">
            <div className="about-img">
              <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702899017/EMarco/Products/2_vcxpe4.png" alt="product" />
            </div>


            <div class="icon-boxes">
              <h3>About Emarco</h3>
              <p>EMarco Capsule helps maintain healthy skin and eyes and strengthens the body's natural
                defence against illness and infection (the immune system).</p>

              <div class="icon-box box1">
                <div class="icon"><svg height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg"><g id="_4" data-name="4"><path d="m53.53857 26.68236a24.43028 24.43028 0 0 0 -21.44726-21.5205 24.12448 24.12448 0 0 0 -18.9961 6.05078 24.42955 24.42955 0 0 0 5.51368 40.11767v60.93262a10.71632 10.71632 0 1 0 21.43261 0v-60.93213a24.32748 24.32748 0 0 0 13.49707-24.64844zm-16.27832 21.52295a1.99891 1.99891 0 0 0 -1.21875 1.84082v62.2168a6.71632 6.71632 0 1 1 -13.43261 0v-62.2168a1.99891 1.99891 0 0 0 -1.21875-1.84082 20.4285 20.4285 0 0 1 -5.627-34.01269 20.10829 20.10829 0 0 1 13.53715-5.18555 21.362 21.362 0 0 1 2.35157.13037 20.41633 20.41633 0 0 1 5.60839 39.06787zm-5.93457 6.21387v51.42871a2 2 0 0 1 -4 0v-51.42871a2 2 0 0 1 4 0zm14.31641 3.96436v7.07128a2.0001 2.0001 0 0 0 2 2h9.25a2.0001 2.0001 0 0 0 2-2v-7.07128a2.0001 2.0001 0 0 0 -2-2h-9.25a2.0001 2.0001 0 0 0 -2 2zm4 2h5.25v3.07128h-5.25zm-2 35.21435h11.18457a2.0001 2.0001 0 0 0 2-2v-7.07178a2.0001 2.0001 0 0 0 -2-2h-11.18457a2.0001 2.0001 0 0 0 -2 2v7.07178a2.0001 2.0001 0 0 0 2 2zm2-7.07178h7.18457v3.07178h-7.18457zm-7.51465-59.11572a12.80177 12.80177 0 1 1 -12.80176-12.82178 12.82615 12.82615 0 0 1 12.80176 12.82178zm21.38965 43.04443v7.07129a2.0001 2.0001 0 0 1 -2 2h-13.875a2.0001 2.0001 0 0 1 -2-2v-7.07129a2.0001 2.0001 0 0 1 2-2h13.875a2.0001 2.0001 0 0 1 2 2zm0 28.14307v7.07129a2.0001 2.0001 0 0 1 -2 2h-13.875a2.0001 2.0001 0 0 1 -2-2v-7.07129a2.0001 2.0001 0 0 1 2-2h13.875a2.0001 2.0001 0 0 1 2 2zm15.44659-59.59619h2.19794v2.20917a7.64983 7.64983 0 0 0 -5.63476 7.36944v5.64453a1.99957 1.99957 0 0 0 .38476 1.1792l5.63477 7.71875a1.99969 1.99969 0 0 0 3.23047 0l5.63476-7.71879a1.99958 1.99958 0 0 0 .38477-1.1792v-5.64449a7.64984 7.64984 0 0 0 -5.63477-7.36944v-2.20917h2.197a7.64329 7.64329 0 0 0 7.36066 5.64453h5.63472a1.9976 1.9976 0 0 0 1.18164-.38672l7.70508-5.64453a1.99936 1.99936 0 0 0 0-3.22656l-7.70508-5.64453a1.9976 1.9976 0 0 0 -1.18164-.38672h-5.63476a7.64329 7.64329 0 0 0 -7.36066 5.64453h-2.197v-2.20917a7.64984 7.64984 0 0 0 5.63477-7.36944v-5.64453a1.99958 1.99958 0 0 0 -.38477-1.1792l-5.63476-7.71875a1.99969 1.99969 0 0 0 -3.23047 0l-5.63477 7.71875a1.99957 1.99957 0 0 0 -.38476 1.1792v5.64453a7.64983 7.64983 0 0 0 5.63476 7.36944v2.20917h-2.1979a7.64289 7.64289 0 0 0 -7.35968-5.64453h-5.63476a1.9976 1.9976 0 0 0 -1.18164.38672l-7.70508 5.64453a1.99936 1.99936 0 0 0 0 3.22656l7.70508 5.64453a1.9976 1.9976 0 0 0 1.18164.38672h5.63476a7.64289 7.64289 0 0 0 7.35968-5.64453zm7.83271 9.57861v4.99219l-3.63477 4.979-3.63476-4.979v-4.99219a3.63478 3.63478 0 1 1 7.26953 0zm-7.26953-23.15722v-4.99219l3.63476-4.979 3.63477 4.979v4.99219a3.63478 3.63478 0 1 1 -7.26953 0zm42.69043 59.96533-7.70508-5.64453a1.99765 1.99765 0 0 0 -1.18164-.38672h-5.63477a7.64289 7.64289 0 0 0 -7.35968 5.64453h-2.19794v-2.20917a7.64983 7.64983 0 0 0 5.63477-7.36944v-5.64453a1.99958 1.99958 0 0 0 -.38477-1.1792l-5.63476-7.71875a1.99969 1.99969 0 0 0 -3.23047 0l-5.63477 7.71875a1.99957 1.99957 0 0 0 -.38476 1.1792v5.64453a7.64983 7.64983 0 0 0 5.63476 7.36944v2.20917h-2.197a7.64328 7.64328 0 0 0 -7.36065-5.64453h-5.63473a1.99763 1.99763 0 0 0 -1.18164.38672l-7.70508 5.64453a1.99936 1.99936 0 0 0 0 3.22656l7.70508 5.64453a1.99763 1.99763 0 0 0 1.18164.38672h5.63477a7.64328 7.64328 0 0 0 7.36065-5.64453h2.197v2.20917a7.64983 7.64983 0 0 0 -5.63476 7.36944v5.64453a1.99957 1.99957 0 0 0 .38476 1.1792l5.63477 7.71875a1.99969 1.99969 0 0 0 3.23047 0l5.63476-7.71875a1.99958 1.99958 0 0 0 .38477-1.1792v-5.64453a7.64983 7.64983 0 0 0 -5.63477-7.36944v-2.20917h2.19794a7.64289 7.64289 0 0 0 7.35968 5.64453h5.63477a1.99765 1.99765 0 0 0 1.18164-.38672l7.70508-5.64453a1.99937 1.99937 0 0 0 0-3.22656zm-37.63672 5.25781h-4.98047l-4.97461-3.64453 4.97461-3.64453h4.98047a3.64454 3.64454 0 0 1 0 7.28906zm28.0957 0h-4.98047a3.64455 3.64455 0 0 1 0-7.28906h4.98047l4.97461 3.64453z" /></g></svg></div>
                <h4 class="title">Key Ingredients</h4>
                <p class="description">Vitamin E.</p>
              </div>

              {/* <div class="icon-box">
                <div class="icon">
                  <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Glyph"><g id="Glyph-2" data-name="Glyph"><path d="m49 2h-34a5 5 0 0 0 -5 5v50a5 5 0 0 0 5 5h36a3.009 3.009 0 0 0 3-3v-52a5 5 0 0 0 -5-5zm3 54h-34a1 1 0 0 0 0 2h34v1a1 1 0 0 1 -1 1h-36a3 3 0 0 1 0-6h34a4.985 4.985 0 0 0 3-1zm0-7a3.009 3.009 0 0 1 -3 3h-33v-48h33a3.009 3.009 0 0 1 3 3z" /><path d="m34 6.5a14.988 14.988 0 0 0 -5.71 28.85l-6.36 6.36a4.5 4.5 0 1 0 6.58 6.14 4.464 4.464 0 0 0 2.99 1.15h11a4.5 4.5 0 0 0 0-9h-6.19a4.489 4.489 0 0 0 .96-3.88 14.989 14.989 0 0 0 -3.27-29.62zm-6.06 32.02 3.18-3.18a2.5 2.5 0 1 1 3.54 3.54l-3.18 3.18zm8.06 8.48h-4.5a2.453 2.453 0 0 1 -1.56-.57l4.42-4.43h1.64zm.34-12.74a4.463 4.463 0 0 0 -6.48-.46 13.008 13.008 0 1 1 6.48.46z" /><path d="m40 18h-2.5v-2.5a3.5 3.5 0 0 0 -7 0v2.5h-2.5a3.5 3.5 0 0 0 0 7h2.5v2.5a3.5 3.5 0 0 0 7 0v-2.5h2.5a3.5 3.5 0 0 0 0-7z" /></g></g></svg>
                </div>
                <h4 class="title">Directions For Use</h4>
                <p class="description">Use as directed by the physician.</p>
              </div> */}
              {/* 
              <div class="icon-box">
                <div class="icon">  <svg id="Layer_1" height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m4.54 54.2 9.32 8.74a.22.22 0 0 0 .3 0l9.3-8.74 1.57-1.48a6 6 0 0 0 0-8.88 7 7 0 0 0 -9.46 0l-1.43 1.35a.24.24 0 0 1 -.3 0l-1.22-1.19a7.16 7.16 0 0 0 -9-.72 6 6 0 0 0 -.62 9.44z" /><path d="m29.94 23.51a8.48 8.48 0 0 0 -2.48 1l-1.46-.46a10.06 10.06 0 0 0 -1.9 1.9l.48 1.51a8.48 8.48 0 0 0 -1 2.48l-1.41.72a9 9 0 0 0 0 2.68l1.41.72a8.48 8.48 0 0 0 1 2.48l-.48 1.51a10.06 10.06 0 0 0 1.9 1.95l1.51-.48a8.48 8.48 0 0 0 2.48 1l.72 1.41a9 9 0 0 0 2.68 0l.72-1.41a8.48 8.48 0 0 0 2.48-1l1.51.48a10.06 10.06 0 0 0 1.9-1.9l-.48-1.51a8.48 8.48 0 0 0 1-2.48l1.41-.72a9 9 0 0 0 0-2.68l-1.41-.72a8.48 8.48 0 0 0 -1-2.48l.48-1.51a10.06 10.06 0 0 0 -1.9-1.9l-1.51.48a8.48 8.48 0 0 0 -2.48-1l-.72-1.41a9 9 0 0 0 -2.68 0zm5.81 8.49a3.75 3.75 0 1 1 -3.75-3.75 3.75 3.75 0 0 1 3.75 3.75z" /><path d="m50 53h-16a1 1 0 0 0 0 2h16a7 7 0 0 0 7-7v-10a7 7 0 0 0 -7-7h-5a1 1 0 0 0 0 2h5a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5z" /><path d="m14 33h5a1 1 0 0 0 0-2h-5a5 5 0 0 1 -5-5v-10a5 5 0 0 1 5-5h8v4a1 1 0 0 0 1.53.85l8-5a1 1 0 0 0 0-1.7l-8-5a1 1 0 0 0 -1.53.85v4h-8a7 7 0 0 0 -7 7v10a7 7 0 0 0 7 7z" /><path d="m50.76 3-.76.76-.76-.76a7.35 7.35 0 0 0 -10.13 0 6.81 6.81 0 0 0 0 9.86l1.46 1.41 8.73 8.42a1 1 0 0 0 .7.31 1 1 0 0 0 .69-.28l8.65-8.34.09-.08 1.46-1.41a6.8 6.8 0 0 0 0-9.86 7.33 7.33 0 0 0 -10.13-.03zm-10.26 8.45a4.81 4.81 0 0 1 0-7 5.33 5.33 0 0 1 7.35 0l1.45 1.4a1 1 0 0 0 .7.28 2.68 2.68 0 0 1 -.51 2.38l-.49.61a4.73 4.73 0 0 0 -.1 5.79l.27.35a2.75 2.75 0 0 1 .49 2.18l-.48 2.41-7.25-7z" /></svg></div>
                <h4 class="title">How Emarco Works</h4>
                <p class="description">Cefuroxime works to harm the bacteria and fight the infection.</p>
              </div> */}

            </div>
          </section>
          {/* End About Section */}

          {/* ======= Indications Section ======= */}
          {/* <section id="indications" className="indications">
            <div className="container">
              <div className="section-title">
                <h2>Indications</h2>
              </div>
              <div className="indications-body">
                <div className="member ">
                  <div className="pic"><img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702732291/Emarco/Indications/Lowers_Cholesterol_rfottv.webp" className="img-fluid" alt="Lowers cholesterol" /></div>
                  <div className="member-info">
                    <h4>Lowers cholesterol</h4>
                  </div>
                </div>
                <div className="member ">
                  <div className="pic"><img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702732288/Emarco/Indications/Appetite_Suppression_yhg0dx.webp" className="img-fluid" alt="Appetite suppression" /></div>
                  <div className="member-info">
                    <h4>Appetite suppression</h4>

                  </div>
                </div>
                <div className="member ">
                  <div className="pic"><img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702732293/Emarco/Indications/Speed_Up_Weight_Loss_mgo6dy.webp" className="img-fluid" alt="Speed up weight loss" /></div>
                  <div className="member-info">
                    <h4>Speed up weight loss</h4>

                  </div>
                </div>
                <div className="member ">
                  <div className="pic"><img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702732289/Emarco/Indications/Improves_Metabolism_Of_Fat_iqgt5y.webp" className="img-fluid" alt="Improves metabolism of fat" /></div>
                  <div className="member-info">
                    <h4>Improves metabolism of fat</h4>

                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* End Indications Section */}

          {/* ======= Benefits Section ======= */}
          <section id="benefits" className="benefits">
            <div className="section-title">
              <h2>Benefits of Emarco</h2>
            </div>

            <div className="benefits-body">
              <div className="benefits-card">
                <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702340816/EMarco/Benefits/1_eo9izk.webp" alt="benefit1" />
                <div className="benefits-card-caption">
                  {/* <h6>In Treatment of Constipation</h6> */}
                  <p>It may help relieve itching caused by minor skin irritations</p>
                </div>
              </div>

              <div className="benefits-card">
                <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702340817/EMarco/Benefits/2_ic7m7q.webp" alt="benefit2" />
                <div className="benefits-card-caption">
                  {/* <h6>Treatment of Hepatic encephalopathy</h6> */}
                  <p>It can also help dry out oozing and weeping from reactions to poisonous plants, such
                    as poison oak, poison ivy, or poison sumac</p>
                </div>
              </div>

              <div className="benefits-card">
                <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702340818/EMarco/Benefits/3_w2tbzz.webp" alt="benefit3" />
                <div className="benefits-card-caption">
                  {/* <h6>In Treatment of Constipation</h6> */}
                  <p>Vitamin E protects cells from damage throughout your body</p>
                </div>
              </div>

              <div className="benefits-card">
                <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1702340819/EMarco/Benefits/4_wzjotk.webp" alt="benefit4" />
                <div className="benefits-card-caption">
                  {/* <h6>In Treatment of Constipation</h6> */}
                  <p>It may also help in stopping skin from losing moisture</p>
                </div>
              </div>

            </div>

          </section>
          {/* End Benefits Section */}

          {/* ======= Safety Section ======= */}
          <div className="safety">
            <div className="container">
              <div className="section-title">
                <h2>Safety Information</h2>
              </div>

              <div className="safety-body">

                <div className="safety-card s-c">
                  <div className="svg">
                    <svg id="Layer_5" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m35.03 15h-4.06c-1.086 0-1.97.884-1.97 1.97l8.001.03c-.001-1.116-.885-2-1.971-2z"></path><path d="m11 49c-2.206 0-4 1.794-4 4s1.794 4 4 4h24v-8h-12-2z"></path><path d="m57 43v-27-3c0-1.103-.897-2-2-2s-2 .897-2 2v2h-2.618l-6-12h-18.382c-1.654 0-3 1.346-3 3v38.002c.836-.629 1.875-1.002 3-1.002zm-3-3h-10v-8h10zm1-11h-12v-2h12zm-12-4v-2h8v2zm12 0h-2v-2h2zm0-6v2h-12v-2zm-29-13h18v4h-18zm-1 32v-12.528c0-1.905 1.059-3.619 2.764-4.472l1.236-.618v-1.382c-1.103 0-2-.897-2-2 0-2.219 1.781-4 3.97-4h4.061c2.189 0 3.97 1.781 3.97 3.97 0 1.133-.897 2.03-2 2.03v1.382l1.235.618c1.705.853 2.764 2.566 2.764 4.472v12.528c0 2.916-7.181 3-8 3s-8-.084-8-3z"></path><path d="m39 37.872v-12.4c0-1.144-.635-2.171-1.658-2.683l-2.342-1.171v-2.618h-4v2.618l-2.342 1.171c-.88.44-1.47 1.262-1.619 2.211h7.961v12h-8v.872c.42.41 2.523 1.128 6 1.128s5.58-.718 6-1.128z"></path><path d="m59 3v10 3 29h-33c-1.304 0-2.416.836-2.829 2h37.829v-44z"></path><path d="m27 27h6v8h-6z"></path><path d="m11 43h7c1.13 0 2.162.391 3 1.026v-38.026c0-1.654-1.346-3-3-3h-7c-4.411 0-8 3.589-8 8v36.026c1.825-2.438 4.727-4.026 8-4.026zm8-4h-2v-2h2zm0-8h-2v-2h2zm-14-10h14v2h-14zm0 4h14v2h-14zm0 4h10v2h-10zm0 4h14v2h-14zm0 4h10v2h-10z"></path><path d="m37 59h-26c-3.309 0-6-2.691-6-6s2.691-6 6-6h9.829c-.413-1.164-1.525-2-2.829-2h-7c-4.411 0-8 3.589-8 8s3.589 8 8 8h28v-12h-2z"></path><path d="m57 3h-8.799l8.799 6.091z"></path><path d="m53.679 9.225-6.039-4.181 3.483 6.968c.332-1.3 1.303-2.347 2.556-2.787z"></path></g></svg>
                  </div>
                  <p>Read the label carefully before use</p>
                </div>

                <div className="safety-card s-c">
                  <div className="svg">
                    <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m145.351 351.064-2.825 8.483 1.315 1.315c12.765 12.765 35.028 12.765 47.793 0l1.315-1.315-2.825-8.483c-7.309 1.245-14.751 2.039-22.396 2.039s-15.086-.794-22.377-2.039z"></path><path d="m194.211 459.034h.892c1.315-6.444 4.14-12.288 7.936-17.382v-14.274c0-10.408 4.052-20.197 11.414-27.551l12.482 12.482c-3.964 3.964-6.241 9.463-6.241 15.069v.088c5.42-2.383 11.37-3.743 17.655-3.743 7.027 0 13.586 1.801 19.482 4.732-7.115-25.988-26.606-47.334-52.392-56.452l-1.342 1.342c-9.702 9.719-22.625 15.069-36.37 15.069s-26.668-5.35-36.378-15.069l-1.342-1.342c-30.87 10.92-52.807 39.353-55.155 72.316l-3.575 50.026h43.485v-66.966c0-5.606-2.278-11.105-6.241-15.069l12.482-12.482c7.362 7.353 11.414 17.143 11.414 27.551v66.966h44.685c-.238-1.801-.547-3.584-.547-5.455v-12.2c.001-9.737 7.919-17.656 17.656-17.656z"></path><path d="m24.898 176.552h10.417v-6.682c0-26.509 10.319-51.43 29.069-70.179l5.12-5.12 10.47 6.983c13.78 9.19 22.846 23.605 25.3 39.689h18.317v-14.001c0-5.606-2.278-11.105-6.241-15.069l12.482-12.482c7.362 7.353 11.414 17.143 11.414 27.551v14.001h35.31v-14.001c0-5.606-2.278-11.105-6.241-15.069l12.482-12.482c7.362 7.353 11.414 17.143 11.414 27.551v14.001h35.31v-14.001c0-5.606-2.278-11.105-6.241-15.069l12.482-12.482c7.362 7.353 11.414 17.143 11.414 27.551v14.001h35.31v-1.51c0-13.745-5.35-26.668-15.069-36.387l12.482-12.482c13.056 13.047 20.242 30.402 20.242 48.87v36.82h10.417l4.758-23.782c1.642-8.227 2.481-16.658 2.481-25.053.001-70.428-57.291-127.719-127.717-127.719h-44.694c-70.435 0-127.726 57.291-127.726 127.718 0 8.395.839 16.817 2.481 25.053z"></path><path d="m167.729 335.448c63.276 0 114.759-51.482 114.759-114.759v-61.793h-194.208v-8.828c0-12.888-6.056-24.903-16.305-32.556-12.305 14.655-19.005 32.99-19.005 52.357v50.82c0 63.277 51.482 114.759 114.759 114.759zm52.965-150.069c9.754 0 17.655 7.901 17.655 17.655s-7.901 17.655-17.655 17.655-17.655-7.901-17.655-17.655 7.901-17.655 17.655-17.655zm-79.448 97.104h42.054c8.81 0 16.728-4.899 20.665-12.774l15.793 7.901c-6.947 13.895-20.921 22.528-36.458 22.528h-42.055v-17.655zm-26.483-97.104c9.754 0 17.655 7.901 17.655 17.655s-7.901 17.655-17.655 17.655-17.655-7.901-17.655-17.655 7.901-17.655 17.655-17.655z"></path><path d="m35.315 194.207h-17.655c-9.737 0-17.655 7.918-17.655 17.655s7.918 17.655 17.655 17.655h18.105c-.194-2.931-.45-5.844-.45-8.828z"></path><path d="m238.349 441.379c-11.494 0-21.204 7.406-24.858 17.655h49.708c-3.646-10.248-13.356-17.655-24.85-17.655z"></path><path d="m388.418 282.483h88.285v17.655h-88.285z"></path><path d="m492.407 360.068c-14.513-5.8-25.441-18.317-29.237-33.492l-2.198-8.783h-56.832l-2.198 8.783c-3.796 15.175-14.724 27.692-29.246 33.492-11.9 4.767-19.597 16.128-19.597 28.946v105.331c0 9.737 7.918 17.655 17.655 17.655h123.586c9.737 0 17.655-7.918 17.655-17.655v-105.331c.009-12.818-7.688-24.179-19.588-28.946zm-6.885 116.622c0 4.873-3.955 8.828-8.828 8.828h-88.276c-4.873 0-8.828-3.955-8.828-8.828v-88.276c0-4.873 3.955-8.828 8.828-8.828h88.276c4.873 0 8.828 3.955 8.828 8.828z"></path><path d="m326.625 476.69h-132.414v12.2c0 12.747 10.364 23.111 23.111 23.111h36.599c8.81 0 16.728-4.899 20.665-12.773l2.445-4.882h49.593c4.864 0 8.828-3.964 8.828-8.828s-3.963-8.828-8.827-8.828z"></path><path d="m317.798 194.207h-17.655v26.483c0 2.984-.256 5.897-.45 8.828h18.105c9.737 0 17.655-7.918 17.655-17.655 0-9.738-7.919-17.656-17.655-17.656z"></path><path d="m441.384 406.069h-17.655v17.655h-17.656v17.655h17.656v17.655h17.655v-17.655h17.655v-17.655h-17.655z"></path></g></g></svg>
                  </div>
                  <p>Keep out of reach of the children</p>
                </div>

                <div className="safety-card s-c">
                  <div className="svg">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"><g id="Layer_25" data-name="Layer 25"><path d="M41,26.1V20a5.00181,5.00181,0,0,0-5-5H31V13h3a3.00883,3.00883,0,0,0,3-3V6a3.00879,3.00879,0,0,0-3-3H10A3.00879,3.00879,0,0,0,7,6v4a3.00883,3.00883,0,0,0,3,3h3v2H8a5.00181,5.00181,0,0,0-5,5V44a5.00181,5.00181,0,0,0,5,5H25.03c-.02-.33-.03-.66-.03-1A23.02217,23.02217,0,0,1,41,26.1ZM32,25a1.003,1.003,0,0,1-1,1H30a1,1,0,0,1,0-2h1A1.003,1.003,0,0,1,32,25ZM10,11a1.003,1.003,0,0,1-1-1V6a1.003,1.003,0,0,1,1-1H34a1.003,1.003,0,0,1,1,1v4a1.003,1.003,0,0,1-1,1ZM7,24H20a1,1,0,0,1,0,2H7a1,1,0,0,1,0-2Zm9,18H7a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Zm6,0H19a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm0-17a1.003,1.003,0,0,1,1-1h4a1,1,0,0,1,0,2H23A1.003,1.003,0,0,1,22,25Z" /><path d="M48,27A21,21,0,1,0,69,48,21.023,21.023,0,0,0,48,27ZM35,48A13.00168,13.00168,0,0,1,53.91,36.42L36.42,53.91A12.9727,12.9727,0,0,1,35,48ZM48,61a12.94272,12.94272,0,0,1-5.89-1.41L59.59,42.11A13.00144,13.00144,0,0,1,48,61Z" /></g></svg>
                  </div>
                  <p>Store in a cool and dry place, away from sunlight</p>
                </div>

                <div id="buy"></div>
              </div>
            </div>
          </div>
          {/* End Safety Section */}


          {/* ======= Buy Section ======= */}
          <section className="buy">
            <div className="container">
              <div className="section-title">
                <h2>Buy</h2>
              </div>
            </div>
            <img fetchpriority="high" rel='preload' src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1701941394/Akcuz/buy_zacr81.webp" alt="delivery boy" />
            <form action="POST" ref={form}>
              <div className="row">
                <input type="text"
                  className="form-control"
                  id="name"
                  placeholder="Your Name"
                  name='Name'
                  value={userData.Name}
                  onChange={postUserData}
                  required />
                <input type="email"
                  className="form-control"
                  id="email"
                  style={{ textTransform: 'lowercase' }}
                  placeholder="Your Email"
                  name='Email'
                  value={userData.Email}
                  onChange={postUserData}
                  required />
              </div>
              <div className="row">
                <input type="text"
                  className="form-control"
                  id="name"
                  placeholder="Your Mobile"
                  name='Mobile'
                  value={userData.Mobile}
                  onChange={postUserData}
                  required />
                <input type="number"
                  min={1}
                  className="form-control"
                  id="name"
                  placeholder="Quantity"
                  name='Quantity'
                  value={userData.Quantity}
                  onChange={postUserData}
                  required />
              </div>
              <input style={{ display: "none" }}
                type="text"
                name="productName"
                value="Emarco"
              />
              <select id="" className="form-control" name='RetailerSelfUse'
                value={userData.RetailerSelfUse}
                onChange={postUserData} >
                <option value="retailer/self use" selected>retailer/ self use</option>
                <option value="Retailer">Retailer</option>
                <option value="Self Use">Self Use</option>
              </select>

              <button type="submit" onClick={SubmitData}>Buy Now</button>
            </form>

          </section>
          {/* End Buy Section */}

        </main>{/* End #main */}

      </div>

      {/* Footer */}
      <footer>
        <div className="footer-body">
          <div className="footer-about">
            <h2>Emarco</h2>
            <p>EMarco Capsule helps maintain healthy skin and eyes and strengthens the body's natural
              defence against illness and infection (the immune system).</p>
          </div>
          <div className="footer-links">
            <h4>useful Links</h4>
            <div className="footer-links-content">
              <a href="/"><svg id="Layer_1" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m16.1 45c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m26.1 20c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m21.1 75c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z" /><path d="m43 55.6-6.6 26.6c-.7 2.7 2.4 4.8 4.6 3.2l46.6-32.9c1.7-1.2 1.7-3.7 0-4.9l-46.6-32.9c-2.3-1.6-5.3.5-4.6 3.2l6.6 26.5c.3 1.3 1.5 2.3 2.9 2.3h7.2c1.1 0 2.1-.5 2.6-1.5 1.7-3.2 5.1-5.3 9-5.2 5.2.1 9.5 4.5 9.7 9.7.2 5.7-4.4 10.3-10 10.3-3.8 0-7-2.1-8.7-5.2-.5-.9-1.5-1.5-2.6-1.5-2 0-5.1 0-7.2 0-1.3 0-2.5 1-2.9 2.3z" /></svg>&emsp;Home</a>

              <a href="#about"><svg id="Layer_1" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m16.1 45c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m26.1 20c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m21.1 75c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z" /><path d="m43 55.6-6.6 26.6c-.7 2.7 2.4 4.8 4.6 3.2l46.6-32.9c1.7-1.2 1.7-3.7 0-4.9l-46.6-32.9c-2.3-1.6-5.3.5-4.6 3.2l6.6 26.5c.3 1.3 1.5 2.3 2.9 2.3h7.2c1.1 0 2.1-.5 2.6-1.5 1.7-3.2 5.1-5.3 9-5.2 5.2.1 9.5 4.5 9.7 9.7.2 5.7-4.4 10.3-10 10.3-3.8 0-7-2.1-8.7-5.2-.5-.9-1.5-1.5-2.6-1.5-2 0-5.1 0-7.2 0-1.3 0-2.5 1-2.9 2.3z" /></svg>&emsp;About Emarco</a>

              <a href="#buy"><svg id="Layer_1" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m16.1 45c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m26.1 20c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m21.1 75c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z" /><path d="m43 55.6-6.6 26.6c-.7 2.7 2.4 4.8 4.6 3.2l46.6-32.9c1.7-1.2 1.7-3.7 0-4.9l-46.6-32.9c-2.3-1.6-5.3.5-4.6 3.2l6.6 26.5c.3 1.3 1.5 2.3 2.9 2.3h7.2c1.1 0 2.1-.5 2.6-1.5 1.7-3.2 5.1-5.3 9-5.2 5.2.1 9.5 4.5 9.7 9.7.2 5.7-4.4 10.3-10 10.3-3.8 0-7-2.1-8.7-5.2-.5-.9-1.5-1.5-2.6-1.5-2 0-5.1 0-7.2 0-1.3 0-2.5 1-2.9 2.3z" /></svg>&emsp;Buy</a>

              <a onClick={down} href="#contact"><svg id="Layer_1" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m16.1 45c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m26.1 20c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z" /><path d="m21.1 75c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z" /><path d="m43 55.6-6.6 26.6c-.7 2.7 2.4 4.8 4.6 3.2l46.6-32.9c1.7-1.2 1.7-3.7 0-4.9l-46.6-32.9c-2.3-1.6-5.3.5-4.6 3.2l6.6 26.5c.3 1.3 1.5 2.3 2.9 2.3h7.2c1.1 0 2.1-.5 2.6-1.5 1.7-3.2 5.1-5.3 9-5.2 5.2.1 9.5 4.5 9.7 9.7.2 5.7-4.4 10.3-10 10.3-3.8 0-7-2.1-8.7-5.2-.5-.9-1.5-1.5-2.6-1.5-2 0-5.1 0-7.2 0-1.3 0-2.5 1-2.9 2.3z" /></svg>&emsp;Contact</a>
            </div>
          </div>
          <div className="footer-contact" style={{ animation: animation }}>
            <h4>Contact info</h4>

            <div className="footer-contact-body">
              <div className="footer-contact-content">
                <div className="svg">
                  <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Call"><path d="m52.5 42.85-2.83-2.82a5.9873 5.9873 0 0 0 -8.48 0l-1.27 1.26a1.9573 1.9573 0 0 1 -1.83.54c-2.1-.47-5.49-1.92-9.74-6.17-4.26-4.26-5.71-7.65-6.18-9.75a1.9573 1.9573 0 0 1 .54-1.83l1.27-1.27a6.01768 6.01768 0 0 0 0-8.48l-2.83-2.83a6.01143 6.01143 0 0 0 -8.48 0l-.87.87a10.64659 10.64659 0 0 0 -2.89 9.89c1.49 6.71 6.41 15.28 11.98 20.85 5.57 5.56 14.14 10.49 20.84 11.98a10.96437 10.96437 0 0 0 2.34.26 10.68538 10.68538 0 0 0 7.56-3.15l.87-.87a6.01143 6.01143 0 0 0 0-8.48z" /></g></svg>
                </div>

                <a href="tel:+91-1145009554">+91-1145009554</a>
              </div>
              <div className="footer-contact-content">
                <div className="svg">
                  <svg viewBox="0 -77 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m490.753906 0h-469.507812l234.753906 234.453125zm0 0" /><path d="m0 21.179688v316.445312l158.425781-158.222656zm0 0" /><path d="m256 276.851562-76.347656-76.25-158.40625 158.203126h469.507812l-158.40625-158.203126zm0 0" /><path d="m353.574219 179.402344 158.425781 158.222656v-316.445312zm0 0" /></svg>
                </div>

                <a href="mailto:akcenthealthcare@gmail.com" style={{ textTransform: 'lowercase' }}>akcenthealthcare@gmail.com</a>
              </div>
              <div className="footer-contact-content">
                <div className="svg">
                  <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-105.6 0-191.5 85.9-191.5 191.5 0 34.4 16.2 77.8 49.4 132.7 27.6 45.6 61.8 90.9 91.9 130.8 13.9 18.4 27 35.8 37.1 50.2 3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8c10.1-14.4 23.2-31.8 37.1-50.2 30.1-39.9 64.2-85.2 91.9-130.8 33.2-54.9 49.4-98.3 49.4-132.7 0-105.6-85.9-191.5-191.5-191.5zm0 280c-48.8 0-88.5-39.7-88.5-88.5s39.7-88.5 88.5-88.5 88.5 39.7 88.5 88.5-39.7 88.5-88.5 88.5z" /></svg>
                </div>

                <a target='_blank' rel='noreferrer' href="https://www.google.com/maps?ll=28.649983,77.145366&z=12&t=m&hl=en&gl=IN&mapclient=embed&cid=6992852429798267520">7/27 Kriti Nagar Industrial Area New Delhi-110015</a>
              </div>
            </div>

            <div className="footer-follow">

              <div className="footer-follow-top">
                <a target="_blank" rel="noreferrer" href="https://www.facebook.com/akcenthealthcaresales/">
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" /></svg>
                </a>

                <a target="_blank" rel="noreferrer" href="https://twitter.com/AkcentHealthca1">
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" /></svg>
                </a>

                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/akcent-healthcare-india-pvt-ltd/about/">
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" /></svg></a>
              </div>
            </div>

          </div>
          <div className="footer-map">
            <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28010.600781844332!2d77.145366!3d28.649983000000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d033a653f51a9%3A0x610b9a3c34da5a80!2sAkcent%20Healthcare%20(INDIA)%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1700049996399!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>

        <div className="footer-copyright">
          <p>© Copyright {new Date().getFullYear()}. All Rights Reserved by <a target="_blank" rel="noreferrer" href="https://www.akcenthealthcare.com">Akcent Healthcare Pvt. Ltd.</a></p>
          <div className="footer-copyright-content">
            <Link to={"/privacy-policy"}>Privacy Policy</Link>
          </div>
        </div>
      </footer >
      {/* Footer Ends */}

    </div>
  )
}

export default Home
